export const getContractFeesPayload = ({ isUpdateVriFees = false, isUpdateOpiFees = false, isUpdateOnsiteFees = false } = {}) => {
  return {
    isUpdateVriFees,
    isUpdateOpiFees,
    isUpdateOnsiteFees
  }
}